import { getRuntimeConfigValue } from './runtime-config';

const rawBffUrl = getRuntimeConfigValue('VITE_BFF_URL');
const normalizedBffUrl = rawBffUrl?.replace(/\/$/, '');

function resolveApiBaseUrl(): string {
  if (import.meta.env.DEV) {
    return '/api/backoffice';
  }

  if (normalizedBffUrl) {
    return normalizedBffUrl.includes('/api/backoffice')
      ? normalizedBffUrl
      : `${normalizedBffUrl}/api/backoffice`;
  }

  throw new Error('Missing VITE_BFF_URL runtime config. Backoffice requires a direct BFF URL.');
}

export const API_BASE_URL = resolveApiBaseUrl();

export function resolveBffApiUrl(path: string): string {
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  if (import.meta.env.DEV) return normalizedPath;
  if (!normalizedBffUrl) throw new Error('Missing VITE_BFF_URL runtime config.');
  const origin = normalizedBffUrl.replace(/\/api\/backoffice\/?$/, '');
  return `${origin}${normalizedPath}`;
}
